import React from 'react';
import { SuspenseWrapper } from '@/modules/global-components/ui/suspense/SuspenseWrapper';

export const withSuspense = (Component: React.ComponentType) => {
  return (
    <SuspenseWrapper>
      <Component />
    </SuspenseWrapper>
  );
};
